"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleChangeComplexity = exports.handleChangeCategory = exports.handleChangeWeightError = exports.handleChangeWeightInput = exports.handleToggleWeight = exports.handleChangePayloadBodyComplexity = exports.handleChangePayloadBodyObjectives = exports.payloadFormatter = exports.handleChangeTotalWeights = exports.getAddedWeight = exports.handleChangeEditedObjectives = exports.getSingleObjective = exports.restructureObjectivesData = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const immer_1 = require("immer");
const restructureObjectivesData = (objectives, fromBadgeWeight) => {
    if (objectives?.length > 0) {
        return objectives?.map((objective) => ({
            ...objective,
            objectiveCategoryId: objective?.objectiveCategory?.id || null,
            isUsingWeight: fromBadgeWeight ||
                (objective?.weight === null ? false : objective?.weight !== 0),
            isWeightError: false
        }));
    }
    return [];
};
exports.restructureObjectivesData = restructureObjectivesData;
const getSingleObjective = (objectiveId, type, get) => {
    const { editedObjectivesData, objectivesData } = get();
    const objectives = type == 'editedObjectives' ? editedObjectivesData : objectivesData;
    const objective = objectives?.find((objective) => {
        return objective.id === objectiveId;
    });
    const objectiveIndex = objectives?.findIndex((objective) => {
        return objective.id === objectiveId;
    });
    return {
        objective,
        objectiveIndex
    };
};
exports.getSingleObjective = getSingleObjective;
const handleChangeEditedObjectives = (objectiveId, newObjective, set) => {
    return set((state) => {
        return {
            ...state,
            editedObjectivesData: state.editedObjectivesData.map((editedObjective) => {
                if (editedObjective?.id === objectiveId) {
                    return {
                        ...editedObjective,
                        ...newObjective
                    };
                }
                return editedObjective;
            })
        };
    });
};
exports.handleChangeEditedObjectives = handleChangeEditedObjectives;
const getAddedWeight = (newWeightValue, currentWeightValue) => {
    const addedWeight = Math.round(Math.pow(10, 13) *
        (newWeightValue - (isNaN(currentWeightValue) ? 0 : currentWeightValue))) / Math.pow(10, 13);
    return addedWeight;
};
exports.getAddedWeight = getAddedWeight;
const handleChangeTotalWeights = (addedWeight, set, get) => {
    const { totalWeights } = get();
    const newWeights = Math.round(Math.pow(10, 13) * (totalWeights + (isNaN(addedWeight) ? 0 : addedWeight))) / Math.pow(10, 13);
    return set({ totalWeights: newWeights });
};
exports.handleChangeTotalWeights = handleChangeTotalWeights;
const payloadFormatter = (objective) => {
    return {
        id: objective?.id,
        weight: objective?.weight,
        objectiveCategoryId: objective?.objectiveCategoryId,
        ...(objective?.parent?.id ? { parentId: objective?.parent?.id } : [])
    };
};
exports.payloadFormatter = payloadFormatter;
const handleChangePayloadBodyObjectives = (editedObjective, set, get) => {
    const { objective: objectiveData } = (0, exports.getSingleObjective)(editedObjective?.id, 'objectivesData', get);
    const payloadBody = get().payloadBody;
    let objectivesPayload = [...payloadBody.objectives];
    const editObjectiveIndex = objectivesPayload?.findIndex((objective) => objective?.id === editedObjective?.id);
    const { objectiveCategoryId, weight } = objectiveData;
    const { objectiveCategoryId: editedObjectiveCategoryId, weight: editedWeight } = editedObjective;
    if (objectiveCategoryId === editedObjectiveCategoryId &&
        weight === editedWeight) {
        objectivesPayload = objectivesPayload?.filter((objective) => {
            return objective?.id !== editedObjective?.id;
        });
    }
    else {
        const formattedObjective = (0, exports.payloadFormatter)(editedObjective);
        if (editObjectiveIndex >= 0) {
            objectivesPayload[editObjectiveIndex] = formattedObjective;
        }
        else {
            objectivesPayload = [...objectivesPayload, formattedObjective];
        }
    }
    return set((0, immer_1.produce)((state) => {
        state.payloadBody.objectives = objectivesPayload;
    }));
};
exports.handleChangePayloadBodyObjectives = handleChangePayloadBodyObjectives;
const handleChangePayloadBodyComplexity = (editedObjective, set) => {
    return set((0, immer_1.produce)((state) => {
        state.payloadBody.complexity = editedObjective?.complexity;
    }));
};
exports.handleChangePayloadBodyComplexity = handleChangePayloadBodyComplexity;
const handleToggleWeight = (objectiveId, get, set) => {
    const { isPercentage, isParent } = get();
    const { objective } = (0, exports.getSingleObjective)(objectiveId, 'editedObjectives', get);
    let newWeightValue = 0;
    if (objective?.weight > 0) {
        newWeightValue = 0;
    }
    else if (isPercentage) {
        newWeightValue = 1;
    }
    else {
        newWeightValue = objective?.objectiveCategory?.weight || 0;
    }
    let addedWeight = 0;
    if (isParent) {
        addedWeight = (0, exports.getAddedWeight)(newWeightValue, objective?.weight);
    }
    const newObjective = {
        ...objective,
        isUsingWeight: !objective?.isUsingWeight,
        weight: newWeightValue
    };
    (0, exports.handleChangeEditedObjectives)(objectiveId, newObjective, set);
    (0, exports.handleChangeTotalWeights)(addedWeight, set, get);
    (0, exports.handleChangePayloadBodyObjectives)(newObjective, set, get);
};
exports.handleToggleWeight = handleToggleWeight;
const handleChangeWeightInput = (objectiveId, inputWeightValue, get, set) => {
    const { objective } = (0, exports.getSingleObjective)(objectiveId, 'editedObjectives', get);
    const newObjective = { ...objective, weight: inputWeightValue };
    let addedWeight = 0;
    const { isParent } = get();
    if (isParent) {
        addedWeight = (0, exports.getAddedWeight)(inputWeightValue || 0, objective?.weight);
    }
    (0, exports.handleChangeEditedObjectives)(objectiveId, newObjective, set);
    (0, exports.handleChangeTotalWeights)(addedWeight, set, get);
    (0, exports.handleChangePayloadBodyObjectives)(newObjective, set, get);
};
exports.handleChangeWeightInput = handleChangeWeightInput;
const handleChangeWeightError = (objectiveId, errorValue, get, set) => {
    const { objective } = (0, exports.getSingleObjective)(objectiveId, 'editedObjectives', get);
    const newObjective = {
        ...objective,
        isWeightError: errorValue
    };
    (0, exports.handleChangeEditedObjectives)(objectiveId, newObjective, set);
};
exports.handleChangeWeightError = handleChangeWeightError;
const handleChangeCategory = (objectiveId, objectiveCategory, get, set) => {
    const { objective } = (0, exports.getSingleObjective)(objectiveId, 'editedObjectives', get);
    let addedWeight = 0;
    const { isParent } = get();
    if (isParent) {
        addedWeight = (0, exports.getAddedWeight)(objectiveCategory.weight || 0, objective?.weight);
    }
    const newObjective = {
        ...objective,
        objectiveCategory,
        objectiveCategoryId: objectiveCategory?.id,
        weight: objectiveCategory?.weight,
        ...(objectiveCategory?.weight > 0 ? { isUsingWeight: true } : [])
    };
    (0, exports.handleChangeEditedObjectives)(objectiveId, newObjective, set);
    (0, exports.handleChangeTotalWeights)(addedWeight, set, get);
    (0, exports.handleChangePayloadBodyObjectives)(newObjective, set, get);
};
exports.handleChangeCategory = handleChangeCategory;
const handleChangeComplexity = (objectiveId, complexityId, get, set) => {
    const { objective } = (0, exports.getSingleObjective)(objectiveId, 'editedObjectives', get);
    const newObjective = { ...objective, complexity: complexityId };
    (0, exports.handleChangeEditedObjectives)(objectiveId, newObjective, set);
    (0, exports.handleChangePayloadBodyComplexity)(newObjective, set);
};
exports.handleChangeComplexity = handleChangeComplexity;
